import { render, staticRenderFns } from "./SchemaColorField.vue?vue&type=template&id=3e94df6a&scoped=true"
import script from "./SchemaColorField.vue?vue&type=script&lang=js"
export * from "./SchemaColorField.vue?vue&type=script&lang=js"
import style0 from "./SchemaColorField.vue?vue&type=style&index=0&id=3e94df6a&prod&lang=scss&scoped=true"
import style1 from "./SchemaColorField.vue?vue&type=style&index=1&id=3e94df6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94df6a",
  null
  
)

export default component.exports